import api from "../lib/api";
import logger from "../utils/logger";



export const getDashboardCourtrooms = () =>
  api.get("/api/controller/dashboard/courtrooms");

export const getDashboardSummary = () =>
  api.get("/api/controller/dashboard/summary");




// ─── Shared types ─────────────────────────────────────────────────────────────

export type FlagStatus = "unresolved" | "masked" | "muted" | "dismissed";

export interface FlagReason {
  id: string;
  label: string;
}

export interface FlagReasonCategory {
  category: string;
  options: FlagReason[];
}

export interface FlagPayload {
  caseNumber: string;
  flagType: string;
  flagSubType: string;
  segmentDuration?: string;
  startTime: number;
  endTime: number;
}

export interface FlagRecord {
  _id: string;
  proceedingId?: string;
  cnr: string;
  courtRoomId?: string;
  flagType: string;
  flagSubType: string;
  flagStatus: FlagStatus;
  description?: string;
  startTime: number;
  endTime?: number;
  segmentDuration?: string;
  timeStamp?: string;
  resolved?: boolean;
}

export interface FullLogParams {
  type?: string;
  status?: string;
  page?: number;
  limit?: number;
}

export interface FullLogMeta {
  total: number;
  page: number;
  limit: number;
  tabs?: Record<string, number>;
}

export interface FullLogResponse {
  data: FlagRecord[];
  meta: FullLogMeta;
}


// ─── GET /api/flagged/get-flag-reason/:category ───────────────────────────────

export async function getFlagReasons(category: string): Promise<FlagReason[]> {
  logger.log("[flagApi] getFlagReasons → category:", category);

  const res = await api.get(`/api/flagged/get-flag-reason/${encodeURIComponent(category)}`);

  const records: FlagReasonCategory[] = res.data?.data ?? [];
  const match = records.find((r) => r.category === category);
  const options = match?.options ?? [];
  return options;
}

// ─── GET /api/flagged ─────────────────────────────────────────────────────────

export async function getAllFlags(page: number) {
  const res = await api.get(
    `/api/flagged/get-all-flag?page=${page}&limit=5`
  );

  return {
    data: res.data?.data ?? [],
    meta: res.data?.meta ?? { total: 0, page: 1, limit: 5 }
  };
}


export async function getFullLog(params: FullLogParams = {}): Promise<FullLogResponse> {
  const res = await api.get("/api/flagged/get-full-log", { params });


  return {
    data: res.data?.data ?? [],
    meta: res.data?.meta ?? { total: 0, page: 1, limit: 10 },
  };



}



// ─── POST /api/flagged ────────────────────────────────────────────────────────

export async function submitFlag(payload: FlagPayload): Promise<FlagRecord> {
  const res = await api.post("/api/flagged", payload);

  if (!res.data?.status) {
    throw new Error(res.data?.error ?? "Failed to submit flag");
  }
  return res.data.data as FlagRecord;
}

// ─── PUT /api/flagged/:id/mask ────────────────────────────────────────────────

export async function maskFlag(flagId: string): Promise<FlagRecord> {


  const res = await api.put(`/api/flagged/${flagId}/mask`);


  if (!res.data?.status) {
    throw new Error(res.data?.error ?? "Failed to mask flag");
  }
  return res.data.data as FlagRecord;
}

// ─── PUT /api/flagged/:id/mute ────────────────────────────────────────────────

export async function muteFlag(flagId: string): Promise<FlagRecord> {

  const res = await api.put(`/api/flagged/${flagId}/mute`);

  if (!res.data?.status) {
    throw new Error(res.data?.error ?? "Failed to mute flag");
  }
  return res.data.data as FlagRecord;
}

// ─── PUT /api/flagged/:id/dismiss ─────────────────────────────────────────────


export async function dismissFlag(flagId: string): Promise<FlagRecord> {


  const res = await api.put(`/api/flagged/${flagId}/dismiss`);


  if (!res.data?.status) {
    throw new Error(res.data?.error ?? "Failed to dismiss flag");
  }
  return res.data.data as FlagRecord;
}

//TimeLine api
export async function getTimeLine() {
  const res = await api.get("/api/timeline");

  return res.data.data;
  

}